/**
 * Routes spécifiques à certaines compagnies.
 * Chaque clé correspond à un nom de route utilisé dans companyConfig.extraRoutes.
 * Le routeur principal sélectionne dynamiquement les routes nécessaires.
 */

// Routes paiement (Stripe) — utilisées par 'demo'
const paymentRoutes = {
  'payments-profile': {
    name: 'payments-profile',
    path: 'payments-profile',
    meta: {
      translate: 'sidebar.payments',
      roles: ['user'],
      requiresAuth: true,
    },
    component: () => import('@/views/profile/ProfilePaymentsList'),
  },
  'payments-account': {
    name: 'payments-account',
    path: 'payments/account',
    meta: {
      translate: 'sidebar.payments',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/payments/PaymentsAccount'),
  },
  'payments-customer-list': {
    name: 'payments-customer-list',
    path: 'payments/customer',
    meta: {
      translate: 'sidebar.payments',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/payments/PaymentsCustomerList'),
  },
  'payments-customer-transaction-list': {
    name: 'payments-customer-transaction-list',
    path: 'payments/customer/transaction/:id',
    meta: {
      translate: 'sidebar.payments',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/payments/PaymentsCustomerTransactionList'),
  },
  'payments-transaction-list': {
    name: 'payments-transaction-list',
    path: 'payments/transaction',
    meta: {
      translate: 'sidebar.payments',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/payments/PaymentsTransactionList'),
  },
  'payments-transaction-view': {
    name: 'payments-transaction-view',
    path: 'payments/transaction/:id',
    meta: {
      translate: 'sidebar.payments',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/payments/PaymentsTransactionView'),
  },
}

// Routes admin supplémentaires — utilisées par 'demo', 'ets', 'mcgill'
const adminRoutes = {
  'other-groupes': {
    name: 'other-groupes',
    path: 'other/groupes',
    meta: {
      translate: 'sidebar.other',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationGroupes'),
  },
  'other-adminClients': {
    name: 'other-adminClients',
    path: 'other/adminclients',
    meta: {
      translate: 'sidebar.other',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationAdminClients'),
  },
  'other-devices': {
    name: 'other-devices',
    path: 'other/devices',
    meta: {
      translate: 'sidebar.other',
      roles: ['admin', 'niveau0'],
      requiresAuth: true,
    },
    component: () => import('@/views/operation/OperationDevices'),
  },
}

// Routes user management — utilisées par 'uqam'
const userManagementRoutes = {
  'usersmanagement-roles': {
    name: 'usersmanagement-roles',
    path: 'usersmanagement/roles',
    meta: {
      translate: 'sidebar.usermanagement',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/userManagement/uqam/UsersManagementRoles.vue'),
  },
  'usersmanagement-roles-users': {
    name: 'usersmanagement-roles-users',
    path: 'usersmanagement/roles/users/:roleId',
    meta: {
      translate: 'sidebar.usermanagement',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/userManagement/uqam/UsersManagementRolesUsers.vue'),
  },
  'usersmanagement-users': {
    name: 'usersmanagement-users',
    path: 'usersmanagement/users',
    meta: {
      translate: 'sidebar.usermanagement',
      roles: ['admin'],
      requiresAuth: true,
    },
    component: () => import('@/views/userManagement/uqam/UsersManagementUsers.vue'),
  },
}

/**
 * Registre de toutes les routes spécifiques disponibles.
 */
export const allCompanyRoutes = {
  ...paymentRoutes,
  ...adminRoutes,
  ...userManagementRoutes,
}

/**
 * Retourne les routes spécifiques pour une compagnie donnée.
 * @param {string[]} routeKeys - Liste des clés de routes à inclure
 * @returns {Object[]} - Tableau d'objets route
 */
export function getCompanyRoutes (routeKeys = []) {
  return routeKeys
    .filter(key => allCompanyRoutes[key])
    .map(key => allCompanyRoutes[key])
}
